enum ActionTypes {
	request = 'DataSourceStatus.request',
	receive = 'DataSourceStatus.receive',
}

export default ActionTypes;
